/* global $ */
import { core } from '@/core'
import Basic from '@basic'
import { Scrollbar } from '@bag'
import Option from './CascaderOption.js'

const util = {
  pullScroll(opt, tar) {
    const option = {
      tag: 'ul',
      barClass: 'cascader-menu',
      wrapClass: 'cascader-menu__wrap',
      viewClass: 'cascader-menu__list',
    }
    const scroll = new Scrollbar(option)
    return scroll
  },
  pullEmptyScroll(opt, tar) {
    const { emptyMember } = opt
    const scroll = this.pullScroll(opt, tar)
    scroll.slot = emptyMember.text('无数据')
    return scroll
  },
  pullOption(opt, tar, value = [], lvl = 0) {
    const scroll = this.pullScroll(opt, tar)
    const { dataId = 'id', dataText = 'text', dataChildren = 'children' } = opt
    if ($.type(value) === 'array') {
      const div = $('<div></div>')
      let options = []
      if (lvl === 0 && value.length === 0) {
        opt.oldDataSet.map(item => item.unit.remove())
        opt.oldDataSet = []
        tar.unit.append(tar.emptyScroll.unit)
        return
      }
      tar.emptyScroll.unit.detach()
      options = value.map(item => {
        const value = item[dataId]
        const label = item[dataText]
        const desc = item[dataChildren] || []
        const option = new Option(Object.assign({}, opt, {
          value,
          label,
          hasChild: desc.length !== 0,
          isActive: tar.valueArrays && tar.valueArrays[lvl] && tar.valueArrays[lvl].includes(value)
        }))
        option.click($.proxy(tar.click, tar))
        option.hover($.proxy(tar.handleOptionHover, tar, desc, lvl))
        div.append(option.unit)
        return option
      })
      scroll.slot = div.children()
      opt.dataSet[lvl] = {
        data: value,
        nodes: options,
        unit: scroll.unit,
      }
      opt.oldDataSet.map((item, index) => {
        if (index >= lvl) {
          item.unit.remove()
        }
      })
      if (value.length > 0) {
        tar.unit.append(scroll.unit)
        opt.oldDataSet = opt.dataSet.map(item => item)
      }
    }
  },
  template: {
    panel() {
      return $('<div class="cascader-panel"></div>')
    },
  },
  updater: {},
}

export default class CascaderPanel extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      dataSet: [],
      oldDataSet: [],
    }
    this.defaults = {}
    this.events = {
      click: 'onClick',
      reset: 'resetData'
    }
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.panel(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.emptyScroll = util.pullEmptyScroll(opt, this)
    this.data = this.settings.data
    core.update(util.updater, opt, this)
  }

  handleOptionHover(desc, lvl) {
    util.pullOption(this.settings, this, desc, lvl + 1)
  }

  onClick(obj) {
    this.value = [obj.value]
  }

  resetData() {
    util.pullOption(this.settings, this, this.settings.data)
  }

  set data(value) {
    this.settings.data = value
    this.resetData()
  }

  get data() {
    return this.settings.data
  }

  set value(value) {
    this.valueArrays = value
  }

  get value() {
    const arr = this.valueArrays || []
    return arr.join(',')
  }
}
